import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb } from '@/ui'
interface Props {
  firstName?: string
  lastName?: string
  userId?: number
}

export const BalanceSheetBreadcrumbs: React.FC<Props> = ({
  firstName,
  lastName,
  userId,
}) => {
  const navigate = useNavigate()
  return (
    <Breadcrumb>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate('/')
            }}
          >
            Dashboard
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate('/admin/finances/list-users')
            }}
          >
            Users
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Link
            onClick={() => {
              navigate(`/admin/finances/records/${userId}`)
            }}
          >
            {firstName} {lastName}
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Page>Balance Sheet</Breadcrumb.Page>
        </Breadcrumb.Item>
      </Breadcrumb.List>
    </Breadcrumb>
  )
}
